<template>
  <div>
    <Modal
      :title="$t('global.permissions') + ' - ' + data.team"
      :hide-footer="true"
      @close="close"
      size="large"
    >
      <template #body>
        <CardTabledList>
          <tr v-for="(permission, index) in data.permissions" v-bind:key="index">
            <td class="pt-3">{{ getRoleName(permission) }}</td>
            <td>
              {{ getActionList(permission) }}
            </td>
          </tr>
        </CardTabledList>
        <div class="form-buttons">
          <Btn variant="primary" type="button" @click="close">
            {{ $t("global.close") }}
          </Btn>
        </div>
      </template>
    </Modal>
  </div>
</template>

<script>
import Btn from "@/components/display/Btn";
import CardTabledList from "@/components/display/card-sub-components/CardTabledList";
import Modal from "@/components/display/Modal";

export default {
  name: "ViewTeamPermissionsModal",
  props: {
    data: Object,
  },
  components: {
    Btn,
    CardTabledList,
    Modal,
  },
  setup(props, { emit, root }) {
    const close = () => {
      emit("close");
    };
    const getActionList = (permission) =>
      permission.actions.length
        ? permission.actions.map((action) => root.$t(`global.permission-name-${action}`)).join(", ")
        : root.$t("global.none");

    const getRoleName = (permission) => root.$t(`global.role-name-${permission.name}`);

    return {
      close,
      getActionList,
      getRoleName,
    };
  },
};
</script>

<style lang="scss" scoped>
@import "~@/styles/variables";
</style>
